import * as yup from "yup";

import { normalizeURLForBackend } from "../utils";

export const INVALID_DOMAIN_ERROR = "Enter a valid domain name.";
export const DUPLICATE_WITHIN_COMPANY_ERROR = "This domain is already added.";

export interface DomainsFormValues {
  primary: string;
  alternatives: { value: string }[];
}

const isValidDomain = (value?: string) => !value || normalizeURLForBackend(value) !== null;

// Duplicate if the normalized value appears >1× across primary + alternatives (this.from[last] = root).
function isUniqueDomain(this: yup.TestContext, value?: string): boolean {
  const normalized = value ? normalizeURLForBackend(value) : null;
  if (!normalized) return true;
  const root = this.from?.[this.from.length - 1]?.value as DomainsFormValues | undefined;
  if (!root) return true;
  const all = [root.primary, ...root.alternatives.map((alt) => alt.value)]
    .map((domain) => normalizeURLForBackend(domain))
    .filter((domain): domain is string => Boolean(domain));
  return all.filter((domain) => domain === normalized).length <= 1;
}

export const websiteDomainsSchema = yup.object({
  primary: yup
    .string()
    .defined()
    .test("valid-domain", INVALID_DOMAIN_ERROR, isValidDomain)
    .test("unique-domain", DUPLICATE_WITHIN_COMPANY_ERROR, isUniqueDomain),
  alternatives: yup
    .array()
    .of(
      yup.object({
        value: yup
          .string()
          .defined()
          .test("valid-domain", INVALID_DOMAIN_ERROR, isValidDomain)
          .test("unique-domain", DUPLICATE_WITHIN_COMPANY_ERROR, isUniqueDomain),
      })
    )
    .defined(),
});
